module.exports = __webpack_public_path__ + "first-5-back.jpg?bfec4679fc795c37f5486d4b13412b8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5-back.jpg
// module id = 510
// module chunks = 0